import React, {useEffect, useState} from "react";
import {Button, Spin, Table} from "antd";
import 'antd/dist/antd.css';
import {LeftOutlined, PlusOutlined, RightOutlined, DownloadOutlined} from "@ant-design/icons";
import {useDispatch, useSelector} from "react-redux";
import {downloadCSV, getAllNewsletters} from "./NewsLetterAction";
import {COUNTRY_CODES} from '../../common/constants'


const NewsLetter = () =>{

    const newsLetter = useSelector(((state) => state.newsLetter?.data || []));
    const [country, setCountry] = useState(['']);
    const [page,setPage] = useState(1);
    const dispatch = useDispatch();
    const pageSize = 15;
    const today = new Date();
    const date = today.getUTCFullYear()+'.'+(today.getUTCMonth())+'.'+today.getUTCDate();

    const downloadFile = () => {
        dispatch(downloadCSV(country, date))
    };

    useEffect(() =>{
        dispatch(getAllNewsletters(country, pageSize, page));
    },[page, country]);

    const handleOnChange = (_,selectedFilters) => {
        selectedFilters.country ?  setCountry(selectedFilters.country) : setCountry([]);
    }

    const columns = [
        {
            title: 'Subscriber',
            dataIndex: 'email',
            key: 'email'
        },
        {
            title: 'Country',
            dataIndex: 'country',
            key: 'country',
            filters: COUNTRY_CODES.map(country => {
                return{
                    text: country.name,
                    value: country.name
                }
            }),
            onFilter: (value, record) => record.country === value,
        },
        {
            title: 'Date',
            dataIndex: 'createdDate',
            key: 'createdDate',
        }
    ];

    return(
        <div>
            <section className="space-listing-section">
                <div className="container">
                    <h1 className="title"> NewsLetter</h1>
                    <p className="btn-csv-download">
                        <Button className="btn-msblue" type="primary" onClick={downloadFile} icon={<DownloadOutlined />} size={"medium"}>Download CSV</Button>
                    </p>
                    {newsLetter.fetching ?<><br/> <br/> <br/><Spin size="large"></Spin> </>: <>
                    <Table className="space-listing-table" dataSource={newsLetter} columns={columns} pagination={false} onChange={handleOnChange}/>
                    <p className="pagination-wrap">
                        <Button type={"default"} size={"medium"} icon={<LeftOutlined/>} onClick={() => {setPage(page-1);}} disabled={page <= 1}/>   {`${page}`}
                        <Button type={"default"} size={"medium"} icon={<RightOutlined/>} onClick={() => {setPage(page+1)}} disabled={newsLetter?.length === 0}/>
                    </p>
                    </>
                    }
                </div>
            </section>
        </div>
    );
}
export default NewsLetter;